var _rect, _mask, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    rx: 2,
    fill: "white"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 20
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 20,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 0H0V1.33333H32V0ZM32 2.66667H0V4H32V2.66667ZM0 5.33334H32V6.66667H0V5.33334ZM32 8H0V9.33333H32V8ZM0 10.6667H32V12H0V10.6667ZM32 13.3333H0V14.6667H32V13.3333ZM0 16H32V17.3333H0V16ZM32 18.6667H0V20H32V18.6667Z",
    fill: "#D02F44"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.7143,
    height: 9.33333,
    fill: "#46467F"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.04773 2.00004C3.04773 2.36823 2.70662 2.66671 2.28583 2.66671C1.86504 2.66671 1.52393 2.36823 1.52393 2.00004C1.52393 1.63185 1.86504 1.33337 2.28583 1.33337C2.70662 1.33337 3.04773 1.63185 3.04773 2.00004ZM6.09534 2.00004C6.09534 2.36823 5.75422 2.66671 5.33343 2.66671C4.91264 2.66671 4.57153 2.36823 4.57153 2.00004C4.57153 1.63185 4.91264 1.33337 5.33343 1.33337C5.75422 1.33337 6.09534 1.63185 6.09534 2.00004ZM8.38105 2.66671C8.80184 2.66671 9.14296 2.36823 9.14296 2.00004C9.14296 1.63185 8.80184 1.33337 8.38105 1.33337C7.96026 1.33337 7.61915 1.63185 7.61915 2.00004C7.61915 2.36823 7.96026 2.66671 8.38105 2.66671ZM12.1906 2.00004C12.1906 2.36823 11.8494 2.66671 11.4287 2.66671C11.0079 2.66671 10.6667 2.36823 10.6667 2.00004C10.6667 1.63185 11.0079 1.33337 11.4287 1.33337C11.8494 1.33337 12.1906 1.63185 12.1906 2.00004ZM3.80965 4.00004C4.23044 4.00004 4.57155 3.70156 4.57155 3.33337C4.57155 2.96519 4.23044 2.66671 3.80965 2.66671C3.38886 2.66671 3.04774 2.96519 3.04774 3.33337C3.04774 3.70156 3.38886 4.00004 3.80965 4.00004ZM7.61916 3.33337C7.61916 3.70156 7.27804 4.00004 6.85725 4.00004C6.43646 4.00004 6.09535 3.70156 6.09535 3.33337C6.09535 2.96519 6.43646 2.66671 6.85725 2.66671C7.27804 2.66671 7.61916 2.96519 7.61916 3.33337ZM9.90483 4.00004C10.3256 4.00004 10.6667 3.70156 10.6667 3.33337C10.6667 2.96519 10.3256 2.66671 9.90483 2.66671C9.48405 2.66671 9.14293 2.96519 9.14293 3.33337C9.14293 3.70156 9.48405 4.00004 9.90483 4.00004ZM12.1906 4.66671C12.1906 5.0349 11.8494 5.33337 11.4287 5.33337C11.0079 5.33337 10.6667 5.0349 10.6667 4.66671C10.6667 4.29852 11.0079 4.00004 11.4287 4.00004C11.8494 4.00004 12.1906 4.29852 12.1906 4.66671ZM8.38105 5.33337C8.80184 5.33337 9.14296 5.0349 9.14296 4.66671C9.14296 4.29852 8.80184 4.00004 8.38105 4.00004C7.96026 4.00004 7.61915 4.29852 7.61915 4.66671C7.61915 5.0349 7.96026 5.33337 8.38105 5.33337ZM6.09534 4.66671C6.09534 5.0349 5.75422 5.33337 5.33343 5.33337C4.91264 5.33337 4.57153 5.0349 4.57153 4.66671C4.57153 4.29852 4.91264 4.00004 5.33343 4.00004C5.75422 4.00004 6.09534 4.29852 6.09534 4.66671ZM2.28583 5.33337C2.70662 5.33337 3.04773 5.0349 3.04773 4.66671C3.04773 4.29852 2.70662 4.00004 2.28583 4.00004C1.86504 4.00004 1.52393 4.29852 1.52393 4.66671C1.52393 5.0349 1.86504 5.33337 2.28583 5.33337ZM4.57155 6.00004C4.57155 6.36823 4.23044 6.66671 3.80965 6.66671C3.38886 6.66671 3.04774 6.36823 3.04774 6.00004C3.04774 5.63185 3.38886 5.33338 3.80965 5.33338C4.23044 5.33338 4.57155 5.63185 4.57155 6.00004ZM6.85725 6.66671C7.27804 6.66671 7.61916 6.36823 7.61916 6.00004C7.61916 5.63185 7.27804 5.33338 6.85725 5.33338C6.43646 5.33338 6.09535 5.63185 6.09535 6.00004C6.09535 6.36823 6.43646 6.66671 6.85725 6.66671ZM10.6667 6.00004C10.6667 6.36823 10.3256 6.66671 9.90483 6.66671C9.48405 6.66671 9.14293 6.36823 9.14293 6.00004C9.14293 5.63185 9.48405 5.33338 9.90483 5.33338C10.3256 5.33338 10.6667 5.63185 10.6667 6.00004ZM11.4287 8.00004C11.8494 8.00004 12.1906 7.70157 12.1906 7.33338C12.1906 6.96519 11.8494 6.66671 11.4287 6.66671C11.0079 6.66671 10.6667 6.96519 10.6667 7.33338C10.6667 7.70157 11.0079 8.00004 11.4287 8.00004ZM9.14296 7.33338C9.14296 7.70157 8.80184 8.00004 8.38105 8.00004C7.96026 8.00004 7.61915 7.70157 7.61915 7.33338C7.61915 6.96519 7.96026 6.66671 8.38105 6.66671C8.80184 6.66671 9.14296 6.96519 9.14296 7.33338ZM5.33343 8.00004C5.75422 8.00004 6.09534 7.70157 6.09534 7.33338C6.09534 6.96519 5.75422 6.66671 5.33343 6.66671C4.91264 6.66671 4.57153 6.96519 4.57153 7.33338C4.57153 7.70157 4.91264 8.00004 5.33343 8.00004ZM3.04773 7.33338C3.04773 7.70157 2.70662 8.00004 2.28583 8.00004C1.86504 8.00004 1.52393 7.70157 1.52393 7.33338C1.52393 6.96519 1.86504 6.66671 2.28583 6.66671C2.70662 6.66671 3.04773 6.96519 3.04773 7.33338Z",
    fill: "url(#paint0_linear)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 1.52393,
    y: 1.33337,
    width: 10.6666,
    height: 7.66667,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 1.52393,
    y1: 1.33337,
    x2: 1.52393,
    y2: 8.00004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F0F0"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUs);
export default __webpack_public_path__ + "static/media/US.0161d97b4562b95bd8e7f2e983158698.svg";
export { ForwardRef as ReactComponent };